import { createSelector } from "@reduxjs/toolkit";

import {
  getNodeTypeIdSelector,
  getSlotPlaceholderIdSelector,
  nodeTypeIdParamSelector,
  type SlotId,
} from "@skilitics/nautilus-core-designer-data";

import type { DesignerNode } from "../../types/index.ts";
import { getManifestSelector } from "./appConfigSelectors.ts";
import { getDesignerNodeByIdSelector } from "./designerNodeSelectors.ts";

export const isPlaceholderNodeSelector = createSelector(
  getManifestSelector,
  nodeTypeIdParamSelector,
  (getManifest, typeId) => getManifest(typeId).terminus.placeholder,
);

export const getIsPlaceholderNodeSelector = createSelector(
  getManifestSelector,
  getNodeTypeIdSelector,
  (getManifest, getTypeId) => (nodeId: number) => getManifest(getTypeId(nodeId)).terminus.placeholder,
);

export const getPlaceholderForSlotIdSelector = createSelector(
  getSlotPlaceholderIdSelector,
  getDesignerNodeByIdSelector,
  (getPlaceholderId, getDesignerNode) =>
    (slotId: SlotId): DesignerNode | undefined => {
      const placeholderId = getPlaceholderId(slotId);
      return placeholderId ? getDesignerNode(placeholderId) : undefined;
    },
);
